<template>
  <path
    d="M18 4.00018L19.82 7.64018C19.9 7.80018 19.78 8.00018 19.6 8.00018H17.62C17.24 8.00018 16.89 7.79018 16.73 7.45018L15 4.00018H13L14.82 7.64018C14.9 7.80018 14.78 8.00018 14.6 8.00018H12.62C12.24 8.00018 11.89 7.79018 11.73 7.45018L10 4.00018H8L9.82 7.64018C9.9 7.80018 9.78 8.00018 9.6 8.00018H7.62C7.24 8.00018 6.89 7.79018 6.72 7.45018L5 4.00018H4C2.9 4.00018 2 4.90018 2 6.00018V18.0002C2 19.1002 2.9 20.0002 4 20.0002H20C21.1 20.0002 22 19.1002 22 18.0002V5.00018C22 4.45018 21.55 4.00018 21 4.00018H18Z"
  />
</template>
